import { GET_USER_SUCCESS } from 'Constants/userConstants';

let defaultState = {
  given_name: '',
  family_name: '',
  email: '',
  roles: [''],
};

const CurrentUserReducer = (state = defaultState, action) => {
  if (action.type === GET_USER_SUCCESS) {
    return {
      ...state,
      ...action.data.user,
    };
  }

  // default case
  return state;
};

export default CurrentUserReducer;
